<div class="create-group-dialog-container">
  <h2 mat-dialog-title>{{ isEditMode ? 'Edit Group' : 'Create New Group' }}</h2>
  <form (ngSubmit)="onSave()" style="display: flex; flex-direction: column; gap: 18px;">
    <div *ngFor="let group of groups; let gIdx = index" class="group-block"
      style="border:1px solid #eee; border-radius:8px; margin-bottom:-12px; padding:18px;">
      <span class="group-number-bg">{{ gIdx + 1 }}</span>
      <button *ngIf="groups.length > 1" mat-icon-button type="button" (click)="deleteGroup(gIdx)"
        class="delete-group-btn" aria-label="Delete Group">
        <span class="material-icons">delete</span>
      </button>
      <div [formGroup]="group.groupForm">
      <div class="custom-field">
        <label for="groupName" class="custom-label" style="color: #06152B;">Group Name</label>
        <input type="text" class="custom-input" [formControl]="group.groupForm.get('groupName')" />
        <div class="custom-error"
          *ngIf="group.groupForm.get('groupName')?.hasError('required') && group.groupForm.get('groupName')?.touched">
          Group name is required
        </div>
      </div>
      <div class="custom-field">
        <label for="groupPosition" class="custom-label" style="color: #06152B;">Group Position</label>
        <select id="groupPosition" class="form-select" [formControl]="group.groupForm.get('groupPosition')"
          [class.invalid]="group.groupForm.get('groupPosition')?.invalid && group.groupForm.get('groupPosition')?.touched">
          <option value="" disabled selected>Select position</option>
          <option *ngFor="let pos of groupPositions" [value]="pos">{{ pos }}</option>
        </select>
        <div class="custom-error"
          *ngIf="group.groupForm.get('groupPosition')?.hasError('required') && group.groupForm.get('groupPosition')?.touched">
          Group position is required
        </div>
      </div>
      <mat-checkbox [formControl]="group.groupForm.get('createSubGroups')" style="color: #06152B;">Create Sub
        Groups</mat-checkbox>
      <div class="custom-field" style="margin-top: 8px;">
        <label for="numberOfSubGroups" class="custom-label">No. of subgroups</label>
        <input id="numberOfSubGroups" type="number" class="custom-input"
          [formControl]="group.groupForm.get('numberOfSubGroups')" min="1"
          [class.invalid]="group.groupForm.get('numberOfSubGroups')?.invalid && group.groupForm.get('numberOfSubGroups')?.touched" />
        <div class="custom-error"
          *ngIf="group.groupForm.get('numberOfSubGroups')?.hasError('required') && group.groupForm.get('numberOfSubGroups')?.touched">
          Number of subgroups is required
        </div>
      </div>
      </div>
              <div *ngFor="let sub of group.subGroupDetails; let subIdx = index" style="margin-bottom: 24px;">
        <div *ngIf="group.groupForm.get('createSubGroups')?.value" style="font-weight: bold; margin-bottom: 8px;">
          {{ sub.name }}
          <button *ngIf="group.subGroupDetails.length > 1" mat-icon-button type="button"
            (click)="deleteSubGroup(gIdx, subIdx)" class="delete-subgroup-btn" aria-label="Delete SubGroup">
            <span class="material-icons">delete</span>
          </button>
        </div>
        <div class="subgroup-form" *ngIf="group.groupForm.get('createSubGroups')?.value">
          <div class="subgroup-fields-row">
            <div class="custom-field">
              <label>Sub Group Name:</label>
              <input 
                type="text" 
                [ngModel]="sub.name" 
                (input)="onSubGroupNameChange(gIdx, subIdx, $event.target.value)"
                [ngModelOptions]="{standalone: true}"
                placeholder="Enter sub group name" 
                maxlength="50"
                class="custom-input"
              />
            </div>
            <div class="custom-field">
              <label>Sub Group Position:</label>
              <select [(ngModel)]="sub.position" [ngModelOptions]="{standalone: true}" class="form-select">
                <option value="" disabled selected>Select position</option>
                <option *ngFor="let pos of groupPositions" [value]="pos">{{ pos }}</option>
              </select>
            </div>
            <div class="custom-field">
              <label>Sub Group Weight:</label>
              <input type="number" [(ngModel)]="sub.weight" [ngModelOptions]="{standalone: true}" placeholder="Enter weight" min="0" max="100" 
                     [class.invalid]="isWeightInvalid(group.subGroupDetails, sub)" />
              <div class="custom-error" *ngIf="isWeightInvalid(group.subGroupDetails, sub)">
                Weight must be between 0-100 and total should equal 100
              </div>
              <small class="weight-helper" *ngIf="!isWeightInvalid(group.subGroupDetails, sub)">
                Total: {{ getTotalSubGroupWeight(group.subGroupDetails) }}/100
              </small>
            </div>
          </div>
        </div>
        <table class="subgroup-table">
          <thead>
            <tr>
              <th class="col-select">Select</th>
              <th class="col-module">Module</th>
              <th class="col-code">Code</th>
              <th class="col-weight">Weight</th>
              <th class="col-position">Position</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let mod of sub.modules; let modIdx = index">
              <td class="col-select">
                <mat-checkbox [(ngModel)]="mod.selected" [ngModelOptions]="{standalone: true}"></mat-checkbox>
              </td>
              <td class="col-module">{{ getModuleDisplayName(mod) }}</td>
              <td class="col-code">{{ mod.code }}</td>
              <td class="col-weight">
                <input matInput type="number" [(ngModel)]="mod.weight" class="subgroup-input"
                  [ngModelOptions]="{standalone: true}"
                  [class.invalid]="isModuleWeightInvalid(mod)" />
              </td>
              <td class="col-position">
                <select [(ngModel)]="mod.position" class="subgroup-input"
                  [ngModelOptions]="{standalone: true}"
                  (ngModelChange)="onModulePositionChange(mod, sub)"
                  [class.invalid]="isModulePositionInvalid(mod, sub)">
                  <option value="" disabled>Select position</option>
                  <option *ngFor="let pos of getPositionsForSubGroup(sub, mod)" [value]="pos">{{ pos }}</option>
                </select>
                <div class="custom-error" *ngIf="isModulePositionInvalid(mod, sub) && mod.selected && mod.position">
                  Position already taken by another module
                </div>
                <!-- <span style="color:red">{{ mod.position }}</span> -->
              </td>
            </tr>
          </tbody>
        </table>
        <div style="margin-top: 8px; margin-bottom: 8px;">
          <small class="weight-helper" [class.custom-error]="getTotalModuleWeight(sub.modules) !== 100">
            Total module weight: {{ getTotalModuleWeight(sub.modules) }}/100
            <span *ngIf="getTotalModuleWeight(sub.modules) !== 100" style="color: #e53935;">
              ({{ getTotalModuleWeight(sub.modules) > 100 ? '+' : '' }}{{ getTotalModuleWeight(sub.modules) - 100 }})
            </span>
          </small>
        </div>
        <!-- <button mat-stroked-button color="primary" type="button" (click)="addModuleToSubGroup(gIdx, subIdx)"
          style="margin-top: 10px;">
          <span class="material-icons" style="vertical-align: middle; margin-right: 4px;">add</span>
          Add Module
        </button> -->
      </div>
      <div *ngIf="group.groupForm.get('createSubGroups')?.value" style="margin-top: 8px;">
        <button mat-stroked-button color="primary" type="button" (click)="addSubGroup(gIdx)">
          <span class="material-icons" style="vertical-align: middle; margin-right: 4px;">add</span>
          Add SubGroup
        </button>

      </div>
    </div>
    <div style="text-align: right; margin-bottom: -10px;">
      <button mat-icon-button color="primary" type="button" (click)="addGroup()">
        <span class="material-icons">add_circle</span>
      </button>
      <span style="vertical-align: middle; margin-left: 4px;">Add Group</span>
    </div>
    <div style="display: flex; justify-content: flex-end; gap: 8px;">

      <button mat-button type="button" (click)="onCancel()">Cancel</button>
      <button mat-flat-button color="primary" type="submit" [disabled]="!isFormValid()">
        Save
      </button>
    </div>
  </form>
</div>